<template>
  <slice
    :id="block._key"
    class="slice--agenda-timeline-product container"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="d-flex flex-direction-column align-center timeline-edge">
      <div class="circle"></div>
      <div class="line"></div>
    </div>

    <div class="pt-md-2">
      <portable-text
        v-if="isTextFilled"
        :blocks="block.text"
        medium
        class="text-center"
      />
    </div>

    <div v-if="productsByMonthsAndYearsOrderedKeys.length > 0" class="w-100">
      <timeline-section
        v-for="key in productsByMonthsAndYearsOrderedKeys"
        :key="key.date"
        :section="productInTimelineByMonthsAndYear[key]"
        class="w-100"
      />
    </div>
    <div v-else class="d-flex flex-direction-column align-center timeline-edge">
      <div class="line"></div>
      <div class="circle"></div>
    </div>
  </slice>
</template>

<script>
import { getMonth, getYear, parse } from 'date-fns'

import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText.vue'
import TimelineSection from '@/components/timeline/section'

export default {
  name: 'AgendaTimelineProductSlice',
  components: { Slice, PortableText, TimelineSection },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    timeline: {},
  }),
  fetch() {
    this.fetchTimeline()
  },
  computed: {
    isTextFilled() {
      return this.block.text?.length > 0
    },
    contextTimeline() {
      return this.timeline[this.$route.params.context]
    },
    productInTimelineByMonthsAndYear() {
      if (!this.contextTimeline || this.contextTimeline.length === 0) return {}

      const productsByMonthsAndYears = {}

      for (const product of this.contextTimeline) {
        const label =
          product.libelle && product.libelle[this.$i18n.locale.substring(0, 2)]
            ? decodeURIComponent(
                product.libelle[this.$i18n.locale.substring(0, 2)]
              )
            : ''

        const catchPhrase =
          product.accroche &&
          product.accroche[this.$i18n.locale.substring(0, 2)]
            ? decodeURIComponent(
                product.accroche[this.$i18n.locale.substring(0, 2)]
              )
            : undefined

        if (product.uid && product.lancement && label && label.length > 0) {
          const date = parse(product.lancement, 'yyyy-MM-dd', new Date())

          if (
            productsByMonthsAndYears[`${getYear(date)}-${getMonth(date)}`] ===
            undefined
          ) {
            productsByMonthsAndYears[`${getYear(date)}-${getMonth(date)}`] = {
              label: this.$d(date, 'month-year'),
              date,
              products: [
                {
                  ...product,
                  date,
                  label,
                  catchPhrase,
                },
              ],
            }
          } else {
            productsByMonthsAndYears[
              `${getYear(date)}-${getMonth(date)}`
            ].products.push({
              ...product,
              date,
              label,
              catchPhrase,
            })
          }
        }
      }

      return productsByMonthsAndYears
    },
    productsByMonthsAndYearsOrderedKeys() {
      return Object.keys(this.productInTimelineByMonthsAndYear).sort((a, b) => {
        return (
          this.productInTimelineByMonthsAndYear[b].date +
          this.productInTimelineByMonthsAndYear[a].date
        )
      })
    },
  },
  mounted() {
    if (!this.$fetchState.pending) {
      this.fetchTimeline()
    }
  },
  methods: {
    async fetchTimeline() {
      this.loading = true
      try {
        this.timeline = await fetch(
          'https://timeline-json.netlify.app/.netlify/functions/getTimeline',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((res) => res.json())
          .then((res) => res.timeline)
      } catch (error) {
        this.$logError.captureException(error)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.slice--agenda-timeline-product {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(var(--spacing) * 1.5);

  @include mq($from: tablet) {
    gap: calc(var(--spacing) * 2);
  }

  &__bis {
    padding: var(--spacing);
    background-color: var(--secondary-color);
    color: var(--tertiary-color);

    @include mq($from: tablet) {
      display: flex;
      align-items: stretch;
      gap: calc(var(--spacing) * 4);
      padding: calc(var(--spacing) * 2);
    }

    .rich_text {
      margin: 0;
    }

    @include mq($from: tablet) {
      .action {
        display: flex;
        align-items: stretch;
        height: auto;
      }

      .action__inner {
        padding: 0 calc(var(--spacing) * 2);
        height: auto;
      }

      .action__text {
        white-space: nowrap;
      }
    }
  }

  .circle {
    --circle-size: #{rem(12px)};

    width: var(--circle-size);
    height: var(--circle-size);
    border-radius: 50%;
    border: rem(1.5px) solid var(--secondary-color);
    background-color: var(--tertiary-color);

    @media (resolution: 1x) {
      border-width: rem(2px);
    }
  }

  .line {
    width: rem(2px);
    min-height: rem(38px);
    background-image: url('~/assets/img/dash-vertical.svg');
    background-size: rem(2px) rem(38px);
    background-repeat: repeat-y;
  }

  .timeline-edge {
    gap: calc(var(--spacing) * 0.6);
  }
}
</style>
